<template>
  <div class="px-20 recomended-brand-tile">
    <div v-if="canShowNynowBadge" class="badge-brand-overlay">
      <badge class="badge color-pink badge--big align-with-brand-image fs-12">
        <a href="/nynow-exhibitor">NY NOW</a>
      </badge>
    </div>
    <router-link :to="item.routerLinkTo" @click.native="trackEvent()">
      <entity-image
        :type="entityImageTypes[index % entityImageTypes.length]"
        :src="item.imageUrl"
        size="height-fixed--240"
        class="width-100"
      />
      <h3 class="text-center mt-20">
        {{ item.title }}
      </h3>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    trackEventDataAccessor: {
      type: Function
    },
    event_id: {
      type: String
    }
  },
  data() {
    return {
      entityImageTypes: ['round-none', 'round-sm', 'retailer']
    }
  },
  computed: {
    canShowNynowBadge() {
      return !!this.item?.event_ids?.includes(this.event_id)
    }
  },
  methods: {
    trackEvent
  }
}

function trackEvent() {
  this.$trackEvent(this.trackEventDataAccessor(this.item))
}
</script>
